import { ICompanyAccount, IUserMDB } from '../../../lib/models/interfaces';

export const calculateComplianceCoins = (
  tokensIn: number,
  tokensOut: number,
  model?: string
) => {
  let inputFactor = 0.00135;
  let outputFactor = 0.0054;
  if (model) {
    switch (true) {
      case model === 'openai.gpt-oss-120b-1:0':
        inputFactor = 0.00015;
        outputFactor = 0.0006;
        break;
      case model ===
        'arn:aws:bedrock:us-west-2:674674125182:inference-profile/us.deepseek.r1-v1:0':
        inputFactor = 0.00135;
        outputFactor = 0.0054;
        break;
    }
  }
  const costInput = (tokensIn / 1000) * inputFactor;
  const costOutput = (tokensOut / 1000) * outputFactor;
  const totalCost = costInput + costOutput;
  const roundedUp = Math.ceil(totalCost * 10) / 10;
  // return totalCost;
  const rounded = Math.round(totalCost * 100) / 100;
  const complianceCoins = roundedUp / 0.1;
  // return complianceCoins;
  return Math.ceil(complianceCoins);
};

export const canAddSeat = (
  companyAccount: ICompanyAccount | null,
  users: IUserMDB[]
) => {
  if (!companyAccount) {
    return false;
  }
  const currentNumUsers = users.filter((ele) => !ele.deactivated).length;

  const subscription = companyAccount.subscriptions.at(-1);
};
